<template>
	
  <div id="app" class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
    <div @click="back()" class="power">
      <i style="cursor: pointer; font-size: 0.6rem" class="el-icon-back"></i>
    </div>
    <div class="otherBtnReport" v-if="true">
      <el-button @click="restSchedule" type="success" round>重置</el-button>
    </div>
    <div class="otherReport" v-if="false">
      <img
        @click="d8Process()"
        style="height: 0.6rem"
        src="../../../assets/img/fr/table.png"
      />
    </div>
      <div class="logoImg">
        <img style="height: 0.8rem" :src="logoSrc" />
      </div>
   <header class="w-100 h-10 flex j-center a-center">
<!-- 		<dv-decoration-5
		  :dur="10"
		  style="position: absolute; bottom: 0; right: 0; height: 50%"
		  class="w-100"
		/> -->
		<div class="font-big font-weight light-title">
		  {{ title ? title : "快反日程表" }}
		</div>
      <!-- <h3 class="title">快速反应跟踪</h3> -->
     <!-- <el-button class="title" type="primary">{{ title }}</el-button> -->
    </header>
	
    <div
      style="text-align: center; margin-top: 20px"
      v-if="leftValue.length < 1"
    >
      <h1 style="color: white; font-size: 20px">没有进行的数据!</h1>
    </div>
    <div class="p w-100 h-90 flex j-center a-center">
        <table class="table-wrapper h-100">
          <thead>
            <tr style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
              <th
                v-for="(val, i) in leftHeader"
                rowspan="2"
                :key="'leftHeader-' + i"
				class="light-title"
				style="font-size: 0.353333rem"
              >
                {{ val }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(tr, ind) in leftValue">
              <tr :key="'leftValue-' + ind">
                <td
                  :class="{
                    ['red']: tr.status == 0,
                  }"
                  :rowspan="tr.list.length"
				  class="light-title font-weight"
				  style="font-size: 0.353333rem"
                >
                  {{ tr.title }}
                </td>
                <td
                  :class="{
                    ['green']: tr.list[0].status == 0,
                  }"
                  @click="changeState(tr.list[0])"
                >
                  {{ tr.list[0].title }}
                </td>
                <td>{{ tr.list[0].frequency }}</td>
                <td>{{ tr.list[0].status == 0 ? "√" : "X" }}</td>
              </tr>
              <template v-for="(td, ix) in tr.list">
                <tr v-if="ix > 0" :key="'leftValue-' + ind + ix">
                  <td
                    @click="changeState(td)"
                    :class="{
                      ['green']: td.status == 0,
                    }"
                  >
                    {{ td.title }}
                  </td>
                  <td>{{ td.frequency }}</td>
                  <td>{{ td.status == 0 ? "√" : "X" }}</td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../router";
import format from "date-fns/format";
export default {
  name: "response-board",
  data() {
    return {
      websock: null,
      reconnectData: null,
      lockReconnect: false,
      logoSrc: "/assets/img/logo_light.png",
      title: "会议日程表",
      msg: "home",
      leftHeader: [], // 表头;
      leftValue: [], // 值;
      rightTopHeader: [], // 表头;
      rightTwoHeader: [], // 二级表头;
      rightValue: [], // 值;
      loading: null,
      issueDialog: false,
      todoDialog: false,
      issueData: {},
      todoData: {},
      colors: { Y: "#FFCC00", R: "#f44", G: "#06bf04" },
      todoTitle: { title: "", groupTitle: "" },
      screen: 1,
      pageSize: 16,
      too: 10000,
    };
  },
  mounted() {
    this.onShow();
    this.loadBoardTitle();
    // 初始化
    this.startLoading();
    //this.webSocket();
    this.init(); //保留http
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  filters: {},
  methods: {
    d8Process() {
      this.$router.push({
        path: "/fr/board",
        query: {
          key: this.$route.query.key,
        }
      });
    },
    oepnIssueDialog(item) {
      this.issueDialog = true;

      API.getIssue(item)
        .then((res) => {
          if (res.success === true) {
            this.issueData = res.value;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadBoardTitle() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }
      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },

    init() {
      this.leftHeader = ["汇报部门", "项目", "频次", "状态"];
      this.loadData();
    },

    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        API.getSchedule()
          .then((res) => {
            if (res.success === true) {
              this.format(res.list);
            }
          })
          .catch((error) => {
            this.endLoading();
            console.log(error);
          });
      }
    },

    restSchedule() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        this.leftValue=[];
        this.startLoading();
        API.restSchedule()
          .then((res) => {
            if (res.success === true) {
              this.loadData();
            }
          })
          .catch((error) => {
            this.endLoading();
            console.log(error);
          });
      }
    },
    //格式化数据
    format(res) {
      this.leftValue = [];
      this.leftValue = res;
      this.screen = Math.ceil(res.length / this.pageSize);
      this.endLoading();
    },
    changeState(item) {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        item["status"] = item["status"] == 1 ? 0 : 1;
        var params = { scheduleId: item["uuid"], status: item["status"] };
        API.changeSchedule(params)
          .then((res) => {
            if (res.success === true) {
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      var uuid = this.$route.query.key;
      if (http) {
        http += "/websocket/fr/issue/keep";
      } else {
        http = "https://demo.biqs.cn/websocket/fr/issue/keep";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("FR socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("FR socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" FR socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      //刷新
      this.init();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    onShow() {
      localStorage.getItem("setUp");
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.pageSize = setUp["pageSize"];
        this.too = setUp["too"] * 1000;
      }
    },
    removeTAG(str) {
      if (str) {
        return str.replace(/<[^>]+>/g, "");
      } else {
        return str;
      }
    },
    formatDate(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "MM/dd HH:mm");
      }
      return "";
    },
    back() {
      router.back();
    },
  },
};
</script>
<style>
	.pagebg {
	  background: url("../../../assets/img/8dbg.png");
	}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/fr/schedule/board.vue